export const NoResults = () => (
  <div className="flex h-full flex-col items-center justify-center">
    <h3>Keine Ergebnisse</h3>
  </div>
);
